import { EP_ADD_MONEY_ADJUSTMENT, EP_CANCEL_MONEY_ADJUSTMENT, EP_DETAILS_MONEY_ADJUSTMENT, EP_EDIT_MONEY_ADJUSTMENT, EP_GET_MONEY_ADJUSTMENTS } from '../constants/endpointConstants';
import api from './Api';


const addMoneyAdjustment = async (formData) => {
    const response = await api.post(EP_ADD_MONEY_ADJUSTMENT, formData);
    return response.data;
};
const getMoneyAdjustmentDetails = async (moneyAdjustmentId) => {
    const response = await api.get(`${EP_DETAILS_MONEY_ADJUSTMENT}/${moneyAdjustmentId}`);
    return response.data;
}
const editMoneyAdjustment = async (formData) => {
    const response = await api.post(EP_EDIT_MONEY_ADJUSTMENT, formData);
    return response.data;
};
const cancelMoneyAdjustment = async (moneyAdjustmentId) => {
    const response = await api.post(EP_CANCEL_MONEY_ADJUSTMENT, moneyAdjustmentId);
    return response.data;
};

const getMoneyAdjustments = async (formData) => {
    const response = await api.post(EP_GET_MONEY_ADJUSTMENTS, formData);
    return response.data;
};

export {addMoneyAdjustment, getMoneyAdjustmentDetails, editMoneyAdjustment, cancelMoneyAdjustment, getMoneyAdjustments}